module.exports = __webpack_public_path__ + "static/media/14UNEP10.b30a3c74.jpg";